import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';
import PageEvent from './events/PageEvent';
import useEventCollector from './useEventCollector';

const usePageTracker = () => {
  const { page } = useEventCollector();
  const { pathname } = useLocation();
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      page(new PageEvent());
    }, 50);
  }, [page, pathname]);
};

export default function PageTracker() {
  usePageTracker();
  return null;
}
